import { tns } from 'tiny-slider/src/tiny-slider'

class InfoCarousel {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniCarousel()

        this._iniMobLoadMore()
    }

    _iniCarousel() {
        this.carouselElem = this.element.querySelector('.s-services__items')

        this.carousel = tns({
            container: this.carouselElem,
            items: 4,
            slideBy: 1,
            nav: false,
            mouseDrag: true,
            loop: false,
            controlsPosition: 'bottom',
            controlsText: ['', ''],
            edgePadding: 0,
            gutter: 26,
            responsive: {
                0: {
                    disable: true,
                },
                768: {
                    disable: false,
                    items: 3,
                },
                1024: {
                    items: 4,
                },
            },
        })
    }

    _iniMobLoadMore() {
        this.element.querySelector('.s-services__more a').addEventListener('click', () => {
            this.element.classList.add('show-all')
        })
    }
}

export default InfoCarousel
